/** Formats clinicianName and clinicianTitle for consistent UI display. */
export const formatClinicianDisplay = (
  clinicianName: string,
  clinicianTitle: string,
  emptyFallback = '—',
): string => {
  const name = clinicianName.trim();
  const title = clinicianTitle.trim();
  if (name && title) return `${name} · ${title}`;
  if (name) return name;
  return emptyFallback;
};
